export enum WoodSpecies {
  Pine = 'Pine',
  Oak = 'Oak',
  Maple = 'Maple',
  Cherry = 'Cherry',
  Walnut = 'Walnut',
  Birch = 'Birch',
  Mahogany = 'Mahogany',
  Cedar = 'Cedar'
}